import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadComponent } from '@check-list/app/shared/dialogs/upload/upload.component';
import { CommonService } from '../common/common.service';
import { UploadEntity } from '@check-list/core/models/upload-entity.model';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(
    private commonService: CommonService,
    private dialog: MatDialog
  ) {}

  storageNavigate(id: string) {
    this.commonService.viewFolder(id);
  }

  openUploadWindow(folders: Record<string, string>, entity: UploadEntity) {
    this.dialog.open(UploadComponent, {
      width: '70vw',
      // height: '80vh',
      data: {
        folders: folders,
        entityData: entity
      }
    });
  }
}
